import { Routes } from "@angular/router";

export const APP_ROUTES: Routes = [
	{
		path: "",
		loadChildren: () => import("./home/home-routing.module").then((r) => r.HOME_ROUTES)
	},
	{
		path: "**",
		redirectTo: "authentication/404"
	}
];
